import {
  GuardianEvent,
  GuardianMessage,
} from 'src/apis/guardian/sub-apis/useGuardianEventsCommunicationService';

const eventTitles = [
  'Annual Sports Day', 'Parent-Teacher Meeting', 'Science Exhibition', 'Class Picnic',
  'Cultural Fest', 'Mathematics Olympiad', 'Debate Competition', 'Art Exhibition',
  'Music Concert', 'Dance Performance', 'Science Fair', 'Tech Hackathon',
  'Literary Festival', 'Career Guidance Session', 'Health Awareness Camp',
  'Environmental Awareness Program', 'Career Fair', 'Inter-School Competition',
  'Quiz Competition', 'Photography Contest', 'Drama Festival', 'Yoga Workshop',
  'Meditation Session', 'Book Fair', 'Career Counseling', 'Graduation Ceremony',
  'Award Ceremony', 'Independence Day Celebration', 'Republic Day Parade',
  'Diwali Celebration', 'Holi Festival', 'Annual Day Function', 'Farewell Party',
  'Welcome Party', 'Teachers Day Celebration', 'Children Day Celebration',
  'Gandhi Jayanti', 'Eco Club Activity', 'Science Club Workshop', 'Math Club Competition',
  'English Literary Club', 'Computer Club Hackathon', 'Sports Club Tournament',
  'Music Club Concert', 'Dance Club Performance', 'Drama Club Show', 'Art Club Exhibition',
  'Photography Club Contest', 'Debate Club Competition', 'Quiz Club Championship',
  'Chess Tournament', 'Swimming Competition', 'Basketball Tournament', 'Cricket Match',
  'Football Match', 'Volleyball Tournament', 'Badminton Championship', 'Table Tennis Competition',
  'Athletics Meet', 'Field Day', 'Science Quiz', 'Math Quiz', 'English Elocution',
  'Storytelling Session', 'Poetry Recitation', 'Essay Writing Competition',
];

const eventTypes: ('school' | 'class' | 'sports' | 'cultural')[] = ['school', 'class', 'sports', 'cultural'];
const eventStatuses: ('upcoming' | 'ongoing' | 'completed')[] = ['upcoming', 'ongoing', 'completed'];
const locations = [
  'School Ground', 'School Auditorium', 'Science Lab', 'City Park', 'Main Hall',
  'Conference Room', 'Library', 'Sports Complex', 'Indoor Stadium', 'Outdoor Stadium',
  'Art Room', 'Music Room', 'Dance Studio', 'Computer Lab', 'Innovation Lab',
];

const times = ['09:00 AM', '02:00 PM', '07:00 PM'];

function generateGuardianEvent(index: number): GuardianEvent {
  const dayOfMonth = Math.floor(index / 3);
  const eventInDay = index % 3;

  const date = new Date(2026, 1, dayOfMonth + 1); // Month is 0-indexed, so 1 = February
  const dateStr = date.toISOString().split('T')[0];

  const titleIndex = index % eventTitles.length;
  const typeIndex = index % eventTypes.length;
  const statusIndex = index % eventStatuses.length;
  const locationIndex = index % locations.length;

  return {
    id: `event-${index + 1}`,
    title: eventTitles[titleIndex],
    description: `${eventTitles[titleIndex]} - A school event organized for students and parents.`,
    date: dateStr,
    time: times[eventInDay],
    location: locations[locationIndex],
    type: eventTypes[typeIndex],
    status: eventStatuses[statusIndex],
  };
}

export const mockGuardianEvents: GuardianEvent[] = Array.from({ length: 84 }, (_, i) => generateGuardianEvent(i));

export const mockGuardianMessages: GuardianMessage[] = [
  {
    id: 'msg-1',
    from: 'Class Teacher',
    subject: 'Assignment Submission Reminder',
    message: 'Please ensure your child submits the science assignment by Friday.',
    date: '2024-01-20',
    read: false,
    priority: 'medium',
  },
  {
    id: 'msg-2',
    from: 'Principal',
    subject: 'School Holiday Notice',
    message: 'School will be closed on 26th January for Republic Day.',
    date: '2024-01-18',
    read: true,
    priority: 'low',
  },
  {
    id: 'msg-3',
    from: 'Sports Teacher',
    subject: 'Sports Day Participation',
    message: 'Your child has been selected to participate in the 100m race. Please confirm attendance.',
    date: '2024-01-15',
    read: false,
    priority: 'high',
  },
  {
    id: 'msg-4',
    from: 'Librarian',
    subject: 'Library Book Due',
    message: 'The book "Introduction to Science" is due for return on 25th January.',
    date: '2024-01-12',
    read: true,
    priority: 'low',
  },
];
